import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const sharedData: Pick<LocDef, 'feature' | 'portal' | 'htmlAllowed' | 'shared'> = {
	feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
	portal: 'CP',
	htmlAllowed: false,
	shared: false,
};

type CpProfileRouteLocs =
	| 'CPProfileAffiliationTitle'
	| 'CPProfileAffiliationPageDescription'
	| 'CPProfileAddressPageDescription'
	| 'CPProfileAddressPageTitle';

export const cpProfileRouteLocs: LocDefs<CpProfileRouteLocs> = {
	CPProfileAddressPageDescription: {
		legacyName: 'CandidateProfile/Profile.Information.Content.PageDescription',
		defaultValue: '',
		description: 'Description for the mailing addresses page.',
		displayPath: `Profile|Addresses|Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateProfileAddresses,
		portal: 'CP',
		htmlAllowed: true,
		shared: false,
	},
	CPProfileAddressPageTitle: {
		legacyName: 'CandidateProfile.Addresses/Profile.Addresses.Title.PageTitle',
		defaultValue: 'My Addresses',
		description: 'Title for the mailing addresses page.',
		displayPath: `Profile|Addresses|Page Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateProfileAddresses,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPProfileAffiliationTitle: {
		...sharedData,
		defaultValue: 'Affiliations',
		description: 'Page title for candidate profile affiliation page.',
		displayPath: 'Profile|Affiliation|Page Title',
		displayType: 'Title',
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Profile.Affiliation.Title.PageTitle',
	},
	CPProfileAffiliationPageDescription: {
		...sharedData,
		defaultValue: null,
		description: 'Title for the personal information section.',
		displayPath: 'Profile|Information|Personal Information',
		displayType: 'Content',
		htmlAllowed: true,
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Profile.Affiliation.Content.PageDescription',
	},
};

export const CpProfileRouteLocs = MapLocKeys<CpProfileRouteLocs>(cpProfileRouteLocs);
